import { render, staticRenderFns } from "./LiveWithBlock.vue?vue&type=template&id=8f727484&scoped=true"
import script from "./LiveWithBlock.vue?vue&type=script&lang=js"
export * from "./LiveWithBlock.vue?vue&type=script&lang=js"
import style0 from "./LiveWithBlock.vue?vue&type=style&index=0&id=8f727484&prod&lang=scss&scoped=true"
import style1 from "./LiveWithBlock.vue?vue&type=style&index=1&id=8f727484&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f727484",
  null
  
)

export default component.exports